module.exports = __webpack_public_path__ + "static/media/mapSubwayLess.a3eb43f5.png";